import angular from "angular";

angular
    .module('app')
    .component('attachFieldForm', {
        template: require('./attach-field-form.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller() {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.fields = $ctrl.resolve.fields;

        $ctrl.selectedFields = $ctrl.resolve.selectedFields;

        $ctrl.displayFields = $ctrl.fields.filter(field => {
            return $ctrl.selectedFields.findIndex(v => v.field_id === field.id) === -1;
        });

        $ctrl.editingField = $ctrl.resolve.editingField;

        $ctrl.selectedField = $ctrl.editingField ? $ctrl.fields.find(v => v.id === $ctrl.editingField.field_id) : null;
        $ctrl.customTitle = $ctrl.editingField ? $ctrl.editingField.custom_title : '';
        $ctrl.defaultValue = $ctrl.editingField ? $ctrl.editingField.default_value : '';
        $ctrl.editOnDirectory = $ctrl.editingField ? $ctrl.editingField.edit_on_directory : false;
        $ctrl.editOnBooking = $ctrl.editingField ? $ctrl.editingField.edit_on_booking : false;
        $ctrl.requiredOnBooking = $ctrl.editingField ? $ctrl.editingField.required_on_booking : false;

        if ($ctrl.defaultValue && !isNaN($ctrl.defaultValue)) {
            $ctrl.defaultValue = +$ctrl.defaultValue;
        }
    };

    $ctrl.submit = () => {
        $ctrl.close({
            $value: {
                field_id: $ctrl.selectedField ? $ctrl.selectedField.id : null,
                field_title: $ctrl.selectedField ? $ctrl.selectedField.title : null,
                custom_title: $ctrl.customTitle,
                default_value: $ctrl.defaultValue ,
                edit_on_directory: $ctrl.editOnDirectory,
                edit_on_booking: $ctrl.editOnBooking,
                required_on_booking: $ctrl.requiredOnBooking,
            }
        })
    };

}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/attach-field-form/attach-field-form.js